export function parseQuoteNumber(value) {
  if (String(value ?? '').trim() === '') return null;
  const number = Number(String(value).replace(',', '.'));
  return Number.isFinite(number) ? number : null;
}

export function quoteTotals(lines) {
  const details = lines.map(line => {
    const quantity = parseQuoteNumber(line.quantity);
    const price = parseQuoteNumber(line.price);
    const vat = parseQuoteNumber(line.vat);
    if (!String(line.description || '').trim() || quantity === null || quantity <= 0 || price === null || price < 0 || vat === null || vat < 0 || vat > 100) return null;
    const ht = Math.round(quantity * price * 100) / 100;
    const tax = Math.round(ht * vat) / 100;
    return { ht, tax, ttc: ht + tax };
  });
  if (details.length === 0 || details.some(detail => detail === null)) return null;
  return {
    details,
    ht: Math.round(details.reduce((sum, detail) => sum + detail.ht, 0) * 100) / 100,
    tax: Math.round(details.reduce((sum, detail) => sum + detail.tax, 0) * 100) / 100,
    ttc: Math.round(details.reduce((sum, detail) => sum + detail.ttc, 0) * 100) / 100,
  };
}
